module.exports = __webpack_public_path__ + "static/img/big_btn2.c3291eb5.png";